import RewardDetailsScreen from 'features/rewards/Details/RewardDetailsScreen';
import React from 'react';

export default function Page() {
  return <RewardDetailsScreen />;
}
